import { ListContentLoader } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { CenteredContent } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Loader = () => (
    <CenteredContent>
        <ListContentLoader
            loaderTitle={translate("auto.keyword.list.generator.body.loader.title")}
            loaderSubtitle={translate("auto.keyword.list.generator.body.loader.subtitle")}
        />
    </CenteredContent>
);
